import React from "react";
import Link from "gatsby-link";
import NavigationBar from "../components/Navigationbar";
import Footer from "../components/Footer";

export default () => (
  <div>
    <NavigationBar />
    <h1>Alumni Section</h1>
    <Footer />
  </div>
);
